/**
 * @file
 * Custom JS behaviour for History.
 */

(function ($) {

  Drupal.behaviors.facetes = {
    attach: function (context, settings) {
      //svar $block_linee_prodotto = $('#block-lineeprodotto');
      // $('#block-lineeprodotto .facets-reset').show();
      /* var $li = $('div#block-lineeprodotto li');
       if ($('input#linee-prodotto-reset-all').attr('checked') === 'checked') {
         $li.addClass('active');
       } else {
         $li.each(function (index) {
           if ($('a', this).hasClass('is-active')) {
             $(this).addClass('active');
           }
         });
       }*/

      var $body = $('body');

     // if ($body.hasClass('path-search-products') && !$body.hasClass('filters-initialized')) {
      /**if ($body.hasClass('path-search-products')) {

        var $expandableSections = $('.block-facet--checkbox');

        $expandableSections.each(function () {

          var $title = $(this).find('> h2');
          var $filters = $(this).find('> .facets-widget-checkbox');
          var $listFilters = $(this).find('> .facets-widget-checkbox > ul');

          $title.click(function (e) {
            e.preventDefault();
            $title.toggleClass('expanded');
            $filters.toggleClass('expanded');
          });

          // Open facet when there are active filters.
          if ($listFilters.hasClass('facet-active')) {
            $title.addClass('expanded');
            $filters.addClass('expanded');
          }

        });

        // Force expanded for facet product line.
        $('.block-facet-blockproduct-lines h2').addClass('expanded')
        $('.block-facet-blockproduct-lines > .facets-widget-checkbox').addClass('expanded')

        $body.addClass('filters-initialized');

      }*/
    }
  };

})(jQuery);

/**
 * var getClosest = function (elem, selector) {

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {
        }
        return i > -1;
      };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) {
      return elem;
    }
  }
  return null;

};
*/
